const NextSmallSVG = ({ top = -62, width = 120, height = 150 }) => {
  const boxStyle = {
    position: 'relative',
    top: top,
    left: 60
  }
  return (
    <div style={boxStyle}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 80 290"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="75" height="312" fill="url(#paint0_linear_175_1231)" />
        <path
          d="M19 114.857L35.4027 133.176C35.7427 133.555 35.7427 134.13 35.4027 134.51L27.5 143.336L19 152.828"
          stroke="#7B39B6"
        />
        <rect x="61" width="19" height="312" fill="#081118" />
        <defs>
          <linearGradient
            id="paint0_linear_175_1231"
            x1="75"
            y1="182"
            x2="-38.5714"
            y2="182"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.371527" stopColor="#081118" />
            <stop offset="0.512152" stopColor="#081118" stopOpacity="0.797587" />
            <stop offset="0.835069" stopColor="#081118" stopOpacity="0.5" />
            <stop offset="1" stopColor="#081118" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  )
}

export default NextSmallSVG
